function arsenalInit(){
  // reference to add my other scripts
  // they are nested at the same level
  var path = getScriptPath('arsenal-init');
  
  addAsset(path+'arsenal-vendor.js', addCustomScripts);

  function addCustomScripts(){
    addAsset(path+'arsenal-custom.js');
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
/*
DOMReady(function() {
  arsenalInit();
});
*/